module.exports = __webpack_public_path__ + "img/file.8126d239.svg";